const searchStoreState = {
  term: '',
  filter: ''
}

export default () => searchStoreState